jQuery(document).ready(function ($){    
    $.noConflict();
 window.addEventListener('message', function(m) {

    if (m.data.type == 'variant_changed') {
      console.log(m);
      if ($("#denominations").length > 0) {
        $("#denominations .form__label p").text($("#denominations input[type=radio]:checked").val());
      }
    }
  });
});